import DefaultProductSearchResultsHtml from './templates/product.search.results.html';

export function ProductSearchCellCtrl ($scope) {
  $scope.defaultProductSearchResultsTemplateUrl = DefaultProductSearchResultsHtml;
}